module.exports = {"id":"217235","name":"Zainadine","rating":"75","photo":"./data/images/photos/2/217235.png","club":{"name":"Marítimo","logo":"./data/images/clubs/Maritimo.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Zainadine0.json
// module id = 4458
// module chunks = 0